export class DeleteAllOrdersService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle({ cPedido }) {
    return await this.httpClient.post(`/v01/pedidos/ExcluiPedido/`, {
      ExcPedido: {
        cPedido,
        cItem: ''
      }
    })
  }
}
